import { getStore as getActivityPaneStore } from 'mini-activity-pane-store/lib/store/Store';
import { lazyExitActivityPane, lazyToggleActivityPane } from 'mini-activity-pane-store';

/**
 * Function called by owa-router when ActivityPane route is encountered
 */
export function onActivityPaneEntryHandler() {
    if (!getActivityPaneStore().isActivityPaneOpen) {
        lazyToggleActivityPane.importAndExecute();
    }
}

/**
 * Function called by owa-router when exiting ActivityPane route.
 */
export function onActivityPaneExitHandler() {
    if (getActivityPaneStore().isActivityPaneOpen) {
        lazyExitActivityPane.importAndExecute();
    }

    return true;
}
